// extracted by mini-css-extract-plugin
export var colorBlack = "#000";
export var colorGray = "gray";
export var colorDarkGray = "#262626";
export var colorLightGray = "#e5e5e5";
export var colorWhite = "#fff";
export var colorElectricBlue = "#0000fe";
export var colorPastelBlue = "#bbe5fe";
export var colorCandyPink = "#f9709a";
export var colorPastelPink = "#ffcdd2";
export var colorDefaultLime = "#cef564";
export var colorPastelLime = "#eeffbe";
export var colorBlueLagoon = "#9cf0e1";
export var colorPastelLagoon = "#ceffec";
export var colorDefaultLavender = "#8738f6";
export var colorPastelLavender = "#eadcff";
export var colorBrightYellow = "#ffe500";
export var colorDefaultGreen = "#12b968";
export var breakpointMedium = "768px";
export var breakpointDesktop = "1024px";
export var breakpointLarge = "1440px";
export var colCount = "6";
export var colWidth = "16.6666666667%";
export var container = "Counter-module--container--7KPGn";
export var active = "Counter-module--active--m3ubg";
export var error = "Counter-module--error--1p-lR";
export var votesText = "Counter-module--votesText--1BVjd";
export var hide = "Counter-module--hide--2Mib-";
export var title = "Counter-module--title--1mPcJ";
export var smallOnMobile = "Counter-module--smallOnMobile--6Ccnd";
export var animatedCircle = "Counter-module--animatedCircle--2S-Yc";
export var full = "Counter-module--full--30qvG";
export var earned = "Counter-module--earned--_J28Y";
export var remaining = "Counter-module--remaining--K71u7";
export var tooltip = "Counter-module--tooltip--2IzK9";
export var content = "Counter-module--content--1enxn";
export var pie = "Counter-module--pie--2c-qa";
export var pointer = "Counter-module--pointer--pT9AI";